import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import {
  Button,
  Modal,
  ModalContent,
  ModalBody,
  ModalHeader,
  ModalCloseButton,
} from '@frontend/components';

import { featureFlagKeys } from 'modules/common/drawers/featureFlagDrawer/const/featureFlagKeys';

import { getQuote } from 'store/quotes/selectors';
import { getFeatureFlagValue } from 'store/session/selectors';

import QuoteItemTable from './QuoteItemTable';
import { workflowStatusOverviewModal } from './data/actions';
import { getIsModalOpen } from './data/reducer';

const connector = connect(
  (state) => ({
    isModalOpen: getIsModalOpen(state),
    isWorkflowsAvailable: getFeatureFlagValue(
      state,
      featureFlagKeys.isWorkflowsAvailable,
    ),
    quote: getQuote(state),
  }),
  {
    closeModal: workflowStatusOverviewModal.close,
  },
);

const WorkflowStatusOverviewModal = ({
  closeModal,
  isModalOpen,
  isWorkflowsAvailable,
  quote,
  showGoToQuoteLink = false,
}) => {
  const quoteNumberWithRevision =
    quote &&
    (quote.revisionNumber
      ? `${quote.number}-${quote.revisionNumber}`
      : quote.number);

  return (
    <Modal
      onClose={closeModal}
      isOpen={isModalOpen}
      size={isWorkflowsAvailable ? 'xl' : 'md'}
    >
      <ModalContent alignSelf="stretch" my={0} h="max-content">
        <ModalHeader>
          {showGoToQuoteLink ? (
            <>
              Workflow Steps
              <Button
                variant="link"
                size="sm"
                ml={1}
                as={Link}
                to={`quotes/edit/${quoteNumberWithRevision}`}
                onClick={closeModal}
              >
                Go To Quote
              </Button>
            </>
          ) : (
            'Workflow Steps'
          )}
          <ModalCloseButton />
        </ModalHeader>
        <ModalBody>
          <QuoteItemTable />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default connector(WorkflowStatusOverviewModal);
